import { Anchor, type _Navigation } from ":shared/components/route";
import { default as routes } from "../routes";
import IdleIcon from "../assets/icons/idle-folder.svg";
import ActiveIcon from "../assets/icons/active-folder.svg";
import { LockedAnchor } from ":src/components/overlays";
import { global } from ":global";
export default function Workshops(props: _Navigation.SideNavJSXItemProps) {
  const $settings = global.store.hooks.platform.useSettings("workshops");
  return (
    <Anchor
      class={`relative  ${props?.anchor?.class}`}
      setup={{
        to: routes,
        classes: {
          active: `${props.anchor.setup.classes.active}`,
        },
      }}
      events={{
        getShouldNavigate: () => !$settings().locked,
      }}
      triggers={{
        onBeforeNavigate: () => {
          if ($settings().locked) {
            global.store.actions.alert.pushToast({
              type: "error",
              message: "This page is locked by admin, you can't access it right now!",
            });
          }
        },
      }}
      components={{
        title: "Workshops",
        idleIcon: <i class="i-grommet-icons:workshop w-24px h-24px text-white opacity-40" />,
        activeIcon: <i class="i-grommet-icons:workshop w-24px h-24px text#p" />,
      }}
    >
      <LockedAnchor locked={$settings().locked} />
    </Anchor>
  );
}
